<div class="fix-modal">
    <div>
        <img src="assets/images/server/error_server.png" alt="" class="img-server">
    </div>

    <div class="text-server">
        Error en el servidor
    </div>
</div>